import type { FollowSessionDependencies } from "../follow-session-dependencies";
import type { FollowRetryState } from "./follow-retry-state";
import { waitForFollowRetry } from "./wait-for-follow-retry";

export async function requestWithFollowRetry<T>(params: {
  operation: () => Promise<T>;
  retry: FollowRetryState;
  maxOutageMs: number | null;
  dependencies: FollowSessionDependencies;
}): Promise<T> {
  for (;;) {
    try {
      const result = await params.operation();
      if (params.retry.warned) {
        params.dependencies.warn("Hepha API recovered; continuing follow.");
      }
      params.retry.failures = 0;
      params.retry.warned = false;
      params.retry.lastWarnedAt = null;
      params.retry.outageStartedAt = null;
      return result;
    } catch (error) {
      await waitForFollowRetry({
        error,
        retry: params.retry,
        maxOutageMs: params.maxOutageMs,
        dependencies: params.dependencies,
      });
    }
  }
}
